import { Factory } from 'rosie';

import random from '../random';
import OptionFactory from './Option';

export const categoryLabels = [
  'Accessories',
  'Trousers',
  'Pumps',
  'Shoes',
  'Clothes',
  'Loafers',
  'Jumpers & cardigans',
  'Travelbags cases',
  'Ballet pumps',
  'Laceup shoes',
  'Underwear',
  'Belt',
  'Jewellery',
  'Hats & caps',
];

const CategoryFactory = new Factory()
  .attr('label', () => random.pickone(categoryLabels))
  .attr('id', () => random.guid({ version: 4 }))
  .attr('options', () => OptionFactory.buildList(5));

export default CategoryFactory;
